import React from 'react'
import { Link } from 'react-router-dom'
import { getAssetUrl } from "../../helper/BaseUrl";

const extractPTags = (html = "") => {
  if (!html) return [];
  return html.match(/<p[^>]*>.*?<\/p>/gi) || [];
};

export default function HomeAbout({homeData}) {
  if (!homeData) return null;

  return (
    <>
    <section className="homeabout">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-6 col-md-6">
                    <div className="homeabout-head">
                        <h1 className="heading">{homeData?.title_section3}</h1>
                        {extractPTags(homeData?.description_section3).map((p, index) => (
                            <p key={index} dangerouslySetInnerHTML={{__html: p.replace(/<\/?p[^>]*>/g, "")}}/>
                        ))}

                        <Link to={homeData?.cta_link_section3} className="default-butn">
                            <span className="text">Learn More</span>
                            <div className="icon-container">
                                <div className="icon icon--left">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                                <div className="icon icon--right">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="homeabout-image">
                        <img src={getAssetUrl(homeData?.image_section3)} alt={homeData?.alt_image_section3 ?? "about"} className="img-responsive wow animate__animated animate__fadeInRight" data-wow-duration="1.3s" data-wow-delay="0.1s" loading="lazy"/>
                    </div>
                </div>

            </div>
        </div>
    </section> 
    </>
  )
}
